import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import Moment from "moment";
import { DatePicker, Loadable, SelectField } from "components/support";

class Filter extends Component {
  static sDateTypes = [
    { value: "opening_date", label: "Abertura" },
    { value: "close_date", label: "Fechamento" }
  ];

  constructor(props) {
    super(props);

    this.state = {
      filters: props.filters,
      changedFilter: false
    };
  }

  handleChange = ({ startDate, endDate, dateType }) => {
    const options = {};
    const { onFilter } = this.props;

    if (dateType) {
      return onFilter({ dateType });
    }

    if (startDate) {
      options.startDate = Moment(startDate).startOf("day");
    }

    if (endDate) {
      options.endDate = Moment(endDate).endOf("day");
    }

    this.setState(prevState => ({
      filters: {
        ...prevState.filters,
        ...options
      }
    }));
  };

  handleDatePicked = () => {
    const { onFilter } = this.props;
    this.setState({ changedFilter: !this.state.changedFilter }, () =>
      onFilter(this.state.filters)
    );
  };

  render() {
    const { loading, filters } = this.props;
    const { dateType } = filters;
    const { startDate, endDate } = this.state.filters;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Loadable
          loading={loading}
          style={{
            display: "flex",
            justifyContent: "space-between",
            flexDirection: "column"
          }}
          shadow
        >
          <Typography type="headline">Filtro</Typography>
          <Row>
            <Col xs={12} md={4}>
              <SelectField
                fullWidth
                options={Filter.sDateTypes}
                label="Tipo de Data"
                value={dateType}
                onChange={(_, dateType) => this.handleChange({ dateType })}
              />
            </Col>
            <Col xs={12} md={8}>
              <DatePicker
                multiple
                label="Período"
                modal
                fullWidth
                startDate={startDate}
                endDate={endDate}
                onChange={this.handleChange}
                onClose={this.handleDatePicked}
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}

export default Filter;



// WEBPACK FOOTER //
// ./src/components/app/history/cash-register-reports/list/filter/index.jsx